<template>
  <div class="profile-image__uploader">
    <div class="profile-image__overlay" @click="handleClose"></div>
    <div class="profile-image__content text-center">
      <img
        @click="handleClose"
        class="profile-image__exit"
        src="~@/assets/media/icons/close.svg"
        alt="close icon"
      />
      <h4>Set Profile Picture</h4>

      <div class="profile-image__content-img">
        <img :src="fileUrl" alt="" v-if="fileUrl" />
        <img :src="avatarPlaceholder" alt="" v-else />
      </div>
      <div class="profile-image__content-file">
        <form
          method="POST"
          enctype="multipart/form-data"
          ref="media"
          @submit.prevent="onSubmitForm"
        >
          <div class="row mx-0">
            <div class="col p-0">
              <div class="form-group">
                <div class="row">
                  <div class="col-md-4">
                    <ActionButton
                      label="Choose file"
                      @customEvent="$refs.image.click()"
                      class="w-100 mt-0"
                      :theme="{ primary, secondary, event, danger }"
                    />
                  </div>
                  <div class="col-md-8 position-relative">
                    <input
                      @click="$refs.image.click()"
                      type="text"
                      v-model="fileName"
                      class="form-control w-100"
                      style="cursor: pointer;"
                      readonly
                    />
                    <img
                      @click="handleReset"
                      class="profile-image__content-file-reset"
                      src="~@/assets/media/icons/close.svg"
                      alt="close icon"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-20">
            <div class="col-12 p-0 justify-content-end d-flex ">
              <ActionButton
                @customEvent="handleClose"
                mode="outline"
                class="mr-10 w-auto"
                :theme="{ primary, secondary, event, danger }"
                label="Cancel"
              />
              <ActionButton
                class="w-auto"
                type="submit"
                :theme="{ primary, secondary, event, danger }"
                label="Upload"
              />

              <input
                class="col-8 col-sm-10 form-control d-none"
                ref="image"
                name="image"
                type="file"
                @change="handleFileChange"
                accept="image/png,image/jpg,image/jpeg,image/gif"
                required
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import mainAxios from "@/helpers/base";

const ActionButton = () => import("@/components/ActionButton");

export default {
  components: {
    ActionButton
  },
  computed: {
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    secondary() {
      return this.$store.state.app.scheme.secondary;
    },
    event() {
      return this.$store.state.app.scheme.event;
    },
    danger() {
      return this.$store.state.app.scheme.danger;
    }
  },
  created() {
    this.fileUrl = this.current;
  },
  data: () => ({
    fileName: "",
    fileUrl: "",
    avatarPlaceholder: require("@/assets/media/avatars/avatar0.jpg")
  }),
  props: {
    current: {
      type: String,
      default: ""
    }
  },
  methods: {
    handleClose() {
      this.$emit("close", false);
    },
    handleFileChange(e) {
      const file = e.target.files[0];
      const fileTypes = e.target.accept;

      if (!file) return;

      if (!file.type || !fileTypes.includes(file.type)) {
        this.$toastr.error(
          "Media selected is not supported. Only GIF, PNG, JPEG are allowed.",
          "Oops!"
        );
        this.handleReset();
        return;
      }

      this.fileName = file.name;
      this.fileUrl = URL.createObjectURL(file);
    },
    handleReset() {
      const input = this.$refs.image;
      input.type = "text";
      input.type = "file";
      this.fileName = "";
      this.fileUrl = this.current;
    },
    reset() {
      const input = this.$refs.image;
      input.type = "text";
      input.type = "file";
      this.fileName = "";
    },
    onSubmitForm() {
      this.$swal({
        title: "Change avatar?",
        text: "Do you really want to change your avatar?",
        type: "info",
        showCancelButton: true,
        confirmButtonText: "Upload",
        reverseButtons: true,
        showLoaderOnConfirm: true,
        allowOutsideClick: () => !this.$swal.isLoading(),
        preConfirm: () => {
          const form = new FormData(this.$refs.media);
          return mainAxios({
            cache: false,
            contentType: "multipart/form-data",
            data: form,
            method: "post",
            processData: false,
            url: "/media/avatar"
          })
            .then(async response => {
              this.reset();
              return response;
            })
            .catch(error => {
              this.$swal.showValidationMessage(error);
            });
        }
      }).then(async ({ value }) => {
        if (value) {
          this.$emit("response", value.data.payload.transforms);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.profile-image {
  &__exit {
    position: absolute;
    top: 40px;
    right: 40px;
    cursor: pointer;
  }
  &__uploader {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    background: rgba(0, 0, 0, 0.5);
    left: 0;
    z-index: 1059;
    height: 100%;
    width: 100%;
  }
  &__content {
    background: white;
    border-radius: 12px;
    margin: 40px auto;
    width: 800px;
    padding: 40px;
    position: relative;
    @media (max-width: 767px) {
      width: 500px;
    }
    @media (max-width: 575px) {
      width: 300px;
    }
    &-img {
      margin: 30px auto;
      border-radius: 50%;
      height: 200px;
      overflow: hidden;
      width: 200px;
      img {
        height: 200px;
        object-fit: cover;
        width: 100%;
      }
    }
    &-file {
      margin: 0 auto;
      max-width: 500px;
      &-reset {
        width: 10px;
        height: 10px;
        margin-left: -20px;
        margin-top: 12px;
        cursor: pointer;
        position: absolute;
        top: 0;
        right: 20px;
      }
    }
  }
  &__overlay {
    background-color: rgba(0, 0, 0, 0.5);
    left: 0;
    min-height: 100vh;
    position: fixed;
    top: 0;
    width: 100%;
  }
}
</style>
